import Avaliacao1 from '../../assets/avaliacao1.png';
import Avaliacao2 from '../../assets/avaliacao2.png';
import Avaliacao3 from '../../assets/avaliacao3.png';
import Avaliacao4 from '../../assets/avaliacao4.png';
import Avaliacao5 from '../../assets/avaliacao5.png';
import Avaliacao6 from '../../assets/avaliacao6.png';
import Avaliacao7 from '../../assets/avaliacao7.png';
import Avaliacao8 from '../../assets/avaliacao8.png';
import Avaliacao9 from '../../assets/avaliacao9.png';
import Avaliacao10 from '../../assets/avaliacao10.png';
import Avaliacao11 from '../../assets/avaliacao11.png';
import Avaliacao12 from '../../assets/avaliacao12.png';
import Avaliacao13 from '../../assets/avaliacao13.png';
import Avaliacao14 from '../../assets/avaliacao14.png';

const avaliacoes = [
  Avaliacao1,
  Avaliacao2,
  Avaliacao3,
  Avaliacao4,
  Avaliacao5,
  Avaliacao6,
  Avaliacao7,
  Avaliacao8,
  Avaliacao9,
  Avaliacao10,
  Avaliacao11,
  Avaliacao12,
  Avaliacao13,
  Avaliacao14,
];

export default avaliacoes;
